const state = {
  documento: {},
  presenteCaixaPostal: false,
  raizPresenteCaixaPostal: false,
  emailInteressado: undefined,
  consolidacaoURL: undefined,
  listaConsolidacoes: []
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/documento/state.js